import React, { useEffect, useState, useCallback } from 'react';
import Layout from '../components/layout/Layout.tsx';
import { listForms, createForm, updateForm } from '../services/api.ts';
import { getRestaurante } from '../../../../services/api.js';


type UUID = string;

interface FormData {
  id?: UUID;
  title?: string;
  nome_estabelecimento?: string;
  nome_robo?: string;
  endereco_completo?: string;
  tom_voz?: string;
  grau_formalidade?: string;
  personalidade_atendimento?: string;
  mensagem_boas_vindas?: string;
  tipos_principais_atendimento?: string;
  acoes_por_tipo_atendimento?: string;
  capacidade_min_max?: string;
  ambientes_espacos_disponiveis?: string;
  extras_opcionais?: string;
  servicos_extras_contrataveis?: string;
  atendimento1_resposta_padrao?: string;
  atendimento2_perguntas_ordem?: string;
  dados_contato_obrigatorios?: string;
  mensagem_final_padrao?: string;
  horarios_funcionamento?: string;
  horarios_salao_delivery?: string;
  datas_especiais_feriados?: string;
  limites_duracao_eventos_mesas?: string;
  politica_orcamento?: string;
  pagamento_salao?: string;
  pagamento_delivery?: string;
  politica_gorjeta_servico?: string;
  politica_cancelamento_reagendamento?: string;
  taxas_extras?: string;
  principais_diferenciais?: string;
  descricao_curta_espaco?: string;
  estrutura_cardapio?: string;
  produtos_principais?: string;
  adicionais_complementos?: string;
  opcoes_especiais_dietas?: string;
  politicas_modificacao_pratos?: string;
  pedido_minimo_delivery?: string;
  tempo_medio_entrega?: string;
  areas_entrega_taxas?: string;
  pacotes_especiais?: string;
  promocoes_ativas?: string;
  programa_fidelidade?: string;
  telefone_whatsapp_oficial?: string;
  instagram_perfil?: string;
  email_oficial?: string;
  site_oficial?: string;
  endereco_resposta_automatica?: string;
  tipos_nao_atendidos?: string;
  convidados_min_eventos_privados?: string;
  regras_barulho_legislacao?: string;
  horarios_corte_operacao?: string;
  criterios_transferencia_humano?: string;
  mensagem_ao_repassar?: string;
  resposta_padrao_preco?: string;
  resposta_quando_nao_entender?: string;
  mensagem_encerramento_cordial?: string;
  tipo_operacao_principal?: string;
  agregadores_delivery?: string;
  pre_encomendas_prazos?: string;
  regras_grandes_grupos?: string;
  politica_rolha_itens_externos?: string;
  atendimento_corporativo_b2b?: string;
  controle_estoque_cardapio?: string;
  tempos_preparo_por_categoria?: string;
  coleta_dados_marketing?: string;
  observacoes_gerais?: string;
  [key: string]: any;
}

const EMPTY: FormData = {};

const fieldClass =
  "w-full px-4 py-2 rounded-lg border border-[#1a2a30] bg-[#19343b] text-white shadow-sm focus:outline-none focus:border-cyan-400 focus:ring-2 focus:ring-cyan-500 disabled:opacity-60 disabled:cursor-not-allowed";

type Field = {
  key: keyof FormData;
  label: string;
  type?: 'input' | 'textarea';
  rows?: number;
};

type Level = {
  id: number;
  title: string;
  fields: Field[];
};

const LEVELS: Level[] = [
  {
    id: 1,
    title: 'Identidade do Estabelecimento',
    fields: [
      { key: 'nome_estabelecimento', label: '1. Nome oficial do estabelecimento:', type: 'input' },
      { key: 'nome_robo', label: '2. Nome do assistente:', type: 'input' },
      { key: 'endereco_completo', label: '3. Endereço completo:', type: 'input' },
      { key: 'tom_voz', label: '4. Tom de voz desejado (acolhedor, profissional, descontraído, formal, etc.):', type: 'input' },
      { key: 'grau_formalidade', label: '5. Grau de formalidade (baixo, intermediário, alto):', type: 'input' },
      { key: 'personalidade_atendimento', label: '6. Personalidade do atendimento (consultiva, acolhedora, objetiva, divertida):', type: 'input' },
      { key: 'mensagem_boas_vindas', label: '7. Mensagem inicial de boas-vindas:', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 2,
    title: 'Objetivo do Atendimento',
    fields: [
      { key: 'tipos_principais_atendimento', label: '8. Quais são os tipos principais de atendimento que o bot deve identificar? (ex.: reservas, locação de espaço, pedidos de delivery, dúvidas gerais, orçamentos)', type: 'textarea', rows: 3 },
      { key: 'acoes_por_tipo_atendimento', label: '9. O que o bot deve fazer em cada tipo de atendimento?', type: 'textarea', rows: 3 },
    ],
  },
  {
    id: 3,
    title: 'Estrutura e Serviços (para espaços / eventos)',
    fields: [
      { key: 'capacidade_min_max', label: '10. Qual é a capacidade mínima e máxima de pessoas?', type: 'input' },
      { key: 'ambientes_espacos_disponiveis', label: '11. Quais são os ambientes e espaços disponíveis? (ex.: salão, área externa, palcos, estacionamento etc.)', type: 'textarea', rows: 3 },
      { key: 'extras_opcionais', label: '12. Quais são os extras opcionais oferecidos? (ex.: iluminação, toldo, telão, técnico de som – com valores se houver)', type: 'textarea', rows: 3 },
      { key: 'servicos_extras_contrataveis', label: '13. Quais serviços extras podem ser contratados? (DJ, cerimonial, hospedagem, fotografia etc.)', type: 'textarea', rows: 3 },
    ],
  },
  {
    id: 4,
    title: 'Fluxo de Atendimento',
    fields: [
      { key: 'atendimento1_resposta_padrao', label: '14. Se for [Atendimento 1], qual deve ser a resposta padrão? (ex.: link de reservas, instrução específica)', type: 'textarea', rows: 3 },
      { key: 'atendimento2_perguntas_ordem', label: '15. Se for [Atendimento 2], quais perguntas o bot deve fazer em ordem? (ex.: tipo de evento, data, horário, nº de convidados, serviços desejados)', type: 'textarea', rows: 4 },
      { key: 'dados_contato_obrigatorios', label: '16. Quais dados de contato devem ser obrigatórios coletar? (nome, telefone, e-mail, WhatsApp)', type: 'input' },
      { key: 'mensagem_final_padrao', label: '17. Qual deve ser a mensagem final padrão após coleta dos dados?', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 5,
    title: 'Horários e Operação',
    fields: [
      { key: 'horarios_funcionamento', label: '18. Quais são os dias e horários de funcionamento?', type: 'input' },
      { key: 'horarios_salao_delivery', label: '19. Existem horários diferentes para salão e delivery?', type: 'input' },
      { key: 'datas_especiais_feriados', label: '20. Existem datas especiais (abre/fecha em feriados)?', type: 'input' },
      { key: 'limites_duracao_eventos_mesas', label: '21. Há tempo limite de duração para eventos ou permanência em mesas?', type: 'input' },
    ],
  },
  {
    id: 6,
    title: 'Políticas Comerciais',
    fields: [
      { key: 'politica_orcamento', label: '22. Como funciona o orçamento? (valores fixos, personalizados, sob consulta)', type: 'textarea', rows: 3 },
      { key: 'pagamento_salao', label: '23. Quais são as formas de pagamento aceitas no salão? (pix, dinheiro, cartão, etc.)', type: 'textarea', rows: 2 },
      { key: 'pagamento_delivery', label: '24. Quais são as formas de pagamento aceitas no delivery? (ex.: pagamento online, maquininha na entrega)', type: 'textarea', rows: 2 },
      { key: 'politica_gorjeta_servico', label: '25. Qual é a política de gorjeta/serviço?', type: 'input' },
      { key: 'politica_cancelamento_reagendamento', label: '26. Qual é a política de cancelamento ou reagendamento?', type: 'textarea', rows: 3 },
      { key: 'taxas_extras', label: '27. Existem taxas extras? (ex.: taxa de entrega, hora extra, limpeza, segurança)', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 7,
    title: 'Diferenciais e Contexto',
    fields: [
      { key: 'principais_diferenciais', label: '28. Quais são os principais diferenciais do estabelecimento? (ex.: localização, tradição, experiência, ambiente exclusivo, delivery rápido, cardápio autoral)', type: 'textarea', rows: 3 },
      { key: 'descricao_curta_espaco', label: '29. Como descrever o espaço em poucas palavras para clientes? (ex.: ambiente charmoso e descontraído com área aberta ampla)', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 8,
    title: 'Gastronomia e Cardápio (para restaurantes/delivery)',
    fields: [
      { key: 'estrutura_cardapio', label: '30. Como o cardápio está estruturado? (categorias – ex.: entradas, pratos principais, sobremesas, bebidas)', type: 'textarea', rows: 3 },
      { key: 'produtos_principais', label: '31. Quais são os pratos ou produtos principais? (itens mais vendidos ou carros-chefe)', type: 'textarea', rows: 3 },
      { key: 'adicionais_complementos', label: '32. Existem adicionais/complementos? (ex.: queijo extra, molhos, acompanhamentos)', type: 'textarea', rows: 2 },
      { key: 'opcoes_especiais_dietas', label: '33. Existem opções especiais? (vegano, vegetariano, sem glúten, sem lactose, apimentado)', type: 'textarea', rows: 2 },
      { key: 'politicas_modificacao_pratos', label: '34. Quais são as políticas de modificação? (ex.: retirar ingredientes, substituir acompanhamentos)', type: 'textarea', rows: 2 },
      { key: 'pedido_minimo_delivery', label: '35. Existe valor mínimo de pedido no delivery?', type: 'input' },
      { key: 'tempo_medio_entrega', label: '36. Qual é o tempo médio de entrega estimado?', type: 'input' },
      { key: 'areas_entrega_taxas', label: '37. Quais são as áreas de entrega atendidas e suas taxas? (bairro X = R$ 6, bairro Y = R$ 12, etc.)', type: 'textarea', rows: 3 },
    ],
  },
  {
    id: 9,
    title: 'Pacotes e Ofertas Especiais',
    fields: [
      { key: 'pacotes_especiais', label: '38. Existem pacotes especiais? (ex.: infantil, corporativo, rodízio, combos, premium)', type: 'textarea', rows: 3 },
      { key: 'promocoes_ativas', label: '39. Existem promoções ativas? (ex.: descontos em determinados dias, combos de delivery)', type: 'textarea', rows: 2 },
      { key: 'programa_fidelidade', label: '40. Existe algum programa de fidelidade? (ex.: pontos, Clube de Mesa, cartão fidelidade)', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 10,
    title: 'Contato e Localização',
    fields: [
      { key: 'telefone_whatsapp_oficial', label: '41. Telefone/WhatsApp oficial:', type: 'input' },
      { key: 'instagram_perfil', label: '42. Instagram ou outra rede social principal:', type: 'input' },
      { key: 'email_oficial', label: '43. E-mail oficial:', type: 'input' },
      { key: 'site_oficial', label: '44. Site (se houver):', type: 'input' },
      { key: 'endereco_resposta_automatica', label: '45. Endereço oficial (para respostas automáticas):', type: 'input' },
    ],
  },
  {
    id: 11,
    title: 'Restrições e Regras',
    fields: [
      { key: 'tipos_nao_atendidos', label: '46. Existem tipos de eventos ou pedidos que não são atendidos? (ex.: festas infantis, grandes volumes, pedidos fora do raio de entrega)', type: 'textarea', rows: 2 },
      { key: 'convidados_min_eventos_privados', label: '47. Existe uma quantidade mínima de convidados para eventos privados?', type: 'input' },
      { key: 'regras_barulho_legislacao', label: '48. Existem regras de barulho ou legislação local que devem ser informadas?', type: 'textarea', rows: 2 },
      { key: 'horarios_corte_operacao', label: '49. Existem horários de corte para delivery ou reservas? (ex.: última chamada até 22h30)', type: 'input' },
    ],
  },
  {
    id: 12,
    title: 'Encaminhamento Humano',
    fields: [
      { key: 'criterios_transferencia_humano', label: '50. Em quais casos o atendimento deve ser transferido para a equipe humana? (ex.: negociação de valores, pedidos complexos, reclamações, problemas com pedidos já feitos)', type: 'textarea', rows: 3 },
      { key: 'mensagem_ao_repassar', label: '51. Qual a forma correta de avisar o cliente quando for repassado?', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 13,
    title: 'Respostas Padrão',
    fields: [
      { key: 'resposta_padrao_preco', label: '52. Resposta padrão sobre preço:', type: 'textarea', rows: 2 },
      { key: 'resposta_quando_nao_entender', label: '53. Resposta quando o bot não entender algo:', type: 'textarea', rows: 2 },
      { key: 'mensagem_encerramento_cordial', label: '54. Mensagem de encerramento cordial:', type: 'textarea', rows: 2 },
    ],
  },
  {
    id: 14,
    title: 'Foodservice Especializado',
    fields: [
      { key: 'tipo_operacao_principal', label: '55. Qual é o tipo de operação principal? (restaurante, delivery, dark kitchen, cafeteria, padaria, food truck, buffet por quilo, etc.)', type: 'input' },
      { key: 'agregadores_delivery', label: '56. O estabelecimento atende por agregadores de delivery? (iFood, Rappi, UberEats) – há diferenças de preço ou promoções nesses canais?', type: 'textarea', rows: 3 },
      { key: 'pre_encomendas_prazos', label: '57. Existem pré-encomendas? (ex.: bolos, ceias de Natal, pratos sob encomenda) → Qual o prazo mínimo?', type: 'textarea', rows: 2 },
      { key: 'regras_grandes_grupos', label: '58. Existem regras para grandes grupos? (ex.: reservas acima de 15 pessoas só antecipadas)', type: 'textarea', rows: 2 },
      { key: 'politica_rolha_itens_externos', label: '59. Existe política de rolha/itens externos? (cliente pode levar bolo, vinho etc.? Há taxa?)', type: 'textarea', rows: 2 },
      { key: 'atendimento_corporativo_b2b', label: '60. O estabelecimento atende empresas (B2B)? (refeições corporativas, convênios com VR/VA, fornecimento em escala)', type: 'textarea', rows: 2 },
      { key: 'controle_estoque_cardapio', label: '61. Existe controle de estoque em tempo real para o cardápio? (precisa sinalizar itens indisponíveis no atendimento)', type: 'textarea', rows: 2 },
      { key: 'tempos_preparo_por_categoria', label: '62. Qual é o tempo médio de preparo por categoria de produto? (ex.: pizza 30 min, prato executivo 15 min)', type: 'textarea', rows: 2 },
      { key: 'coleta_dados_marketing', label: '63. O bot deve coletar dados de marketing? (nome, aniversário, prato favorito, feedbacks, avaliações no Google)', type: 'textarea', rows: 2 },
      { key: 'observacoes_gerais', label: 'Observações gerais:', type: 'textarea', rows: 3 },
    ],
  },
];


interface FieldInputProps {
  field: Field;
  value: string;
  isDisabled: boolean;
  onEdit: (key: keyof FormData) => void;
  onChange: (key: keyof FormData, value: string) => void;
}

const FieldInput: React.FC<FieldInputProps> = ({ field, value, isDisabled, onEdit, onChange }) => {
  const { key, label, type = 'input', rows = 3 } = field;

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between mb-1">
        <label htmlFor={String(key)} className="text-sm font-medium text-cyan-100">
          {label}
        </label>
        {isDisabled && (
          <button
            type="button"
            onClick={() => onEdit(key)}
            className="inline-flex items-center gap-1 px-2 py-1 rounded bg-white/10 text-white text-xs hover:bg-white/20"
            title="Editar campo"
          >
            Editar
          </button>
        )}
      </div>
      {type === 'textarea' ? (
        <textarea
          id={String(key)}
          className={fieldClass}
          rows={rows}
          value={value}
          onChange={(e) => onChange(key, e.target.value)}
          disabled={isDisabled}
        />
      ) : (
        <input
          id={String(key)}
          className={fieldClass}
          value={value}
          onChange={(e) => onChange(key, e.target.value)}
          disabled={isDisabled}
        />
      )}
    </div>
  );
};


const Dashboard = () => {
  const [formData, setFormData] = useState<FormData>({ ...EMPTY });
  const [initialData, setInitialData] = useState<FormData>({ ...EMPTY });
  const [editingId, setEditingId] = useState<UUID | null>(null);
  const [activeLevel, setActiveLevel] = useState<number>(1);
  const [editingFields, setEditingFields] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);
  const [restaurante, setRestaurante] = useState<any | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const r = await getRestaurante();
        setRestaurante(r);
        const data = await listForms(r?.id);
        if (Array.isArray(data) && data.length > 0) {
          const loadedData = data[0];
          setFormData(loadedData);
          setInitialData(loadedData);
          setEditingId(loadedData.id);
        } else {
          setFormData({ ...EMPTY });
          setInitialData({ ...EMPTY });
          setEditingId(null);
        }
      } catch (err) {
        console.error('Erro ao carregar formulário', err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const nomeRestaurante = restaurante?.nome;

  const startEditField = useCallback((key: keyof FormData) => {
    setEditingFields(prev => ({ ...prev, [String(key)]: true }));
  }, []);

  const handleChange = useCallback((key: keyof FormData, value: string) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      let savedData;
      if (editingId) {
        savedData = await updateForm(editingId, formData, restaurante?.id);
      } else {
        savedData = await createForm(formData, restaurante?.id);
        setEditingId(savedData.id);
      }
      setFormData(savedData);
      setInitialData(savedData);
      setEditingFields({});
    } catch (err) {
      console.error('Erro ao salvar formulário', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="max-w-7xl mx-auto text-cyan-50">
        <div className="bg-[#11282E] rounded-2xl p-0 shadow-lg overflow-hidden">
          <div className="px-8 pt-6 pb-4 border-b border-[#1a2a30]">
            {/* TÍTULO ATUALIZADO AQUI */}
            <h2 className="text-2xl font-bold text-cyan-100">
              Formulário Atendimento{nomeRestaurante ? ` – ${nomeRestaurante}` : ''}
            </h2>
          </div>
          <div className="flex flex-col md:flex-row">
            <aside className="w-full md:w-64 border-b md:border-b-0 md:border-r border-[#1a2a30] bg-[#0f2430] p-4">
              <div className="text-xs uppercase tracking-wider text-cyan-300/80 mb-3">Níveis</div>
              <ul className="space-y-1">
                {LEVELS.map(l => (
                  <li key={l.id}>
                    <button
                      type="button"
                      onClick={() => setActiveLevel(l.id)}
                      className={`w-full text-left px-3 py-2 rounded-lg text-sm transition ${
                        activeLevel === l.id
                          ? 'bg-white/15 text-white'
                          : 'text-cyan-200 hover:bg-white/10 hover:text-white'
                      }`}
                    >
                      <span className="mr-2 inline-flex items-center justify-center w-5 h-5 rounded bg-white/20 text-white text-[11px]">
                        {l.id}
                      </span>
                      {l.title}
                    </button>
                  </li>
                ))}
              </ul>
            </aside>
            <main className="flex-1 p-6">
              {loading && <div className="text-center text-cyan-200">A carregar dados...</div>}
              {!loading && (
                <form onSubmit={e => { e.preventDefault(); handleSave(); }} className="space-y-6">
                  {LEVELS.filter(l => l.id === activeLevel).map(level => (
                    <section key={level.id} className="border border-[#1a2a30] rounded-xl p-5 bg-[#132f36] space-y-4">
                      <h3 className="text-lg font-semibold mb-4 text-cyan-100">
                        {`Nível ${level.id} – ${level.title}`}
                      </h3>
                      <div className="grid grid-cols-1 gap-4">
                        {level.fields.map(f => {
                          const hasInitialText = typeof initialData[f.key] === 'string' && initialData[f.key].trim() !== '';
                          const isBeingEdited = !!editingFields[String(f.key)];
                          const isDisabled = hasInitialText && !isBeingEdited;
                          
                          return (
                            <FieldInput
                              key={String(f.key)}
                              field={f}
                              value={(formData[f.key] as string) ?? ''}
                              isDisabled={isDisabled}
                              onEdit={startEditField}
                              onChange={handleChange}
                            />
                          );
                        })}
                      </div>
                    </section>
                  ))}
                  <div className="flex justify-end gap-3">
                    <button
                      type="submit"
                      disabled={loading}
                      className="px-6 py-2 rounded-lg font-semibold bg-gradient-to-r from-cyan-400 to-teal-400 text-[#0e2222] hover:from-teal-500 hover:to-cyan-400 transition disabled:opacity-60"
                    >
                      {loading ? 'A salvar...' : 'Salvar'}
                    </button>
                  </div>
                </form>
              )}
            </main>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
